import { useEffect } from 'react';

import { history } from '../../../../symphony';

import { getQuestionAlias } from '../../utils/helpers';
import { SlDiscussContext } from '../../global-constants';
import { SlDataService } from '../../services/sl-data.service';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';

export const useLeaveQuestion = ({ questionId, title }) => {
	const {
		isQuestionPosted$: isQuestionPosted,
		isQuestionEdited$: isQuestionEdited,
		isQuestionDeleted$: isQuestionDeleted,
		isQuestionNotExist$: isQuestionNotExist,
	} = useContainerData(SlDiscussContext, SlDataService, [
		'isQuestionPosted$',
		'isQuestionEdited$',
		'isQuestionDeleted$',
		'isQuestionNotExist$',
	]);

	useEffect(() => {
		const unblock = history.block((tx) => {
			if (
				isQuestionPosted
				|| isQuestionEdited
				|| isQuestionDeleted
				|| isQuestionNotExist
				|| tx.location.pathname === '/users/signup'
				|| window.confirm('Changes you made may not be saved.')
			) {
				unblock();
				tx.retry();
			}
		});

		return () => {
			unblock();
		};
	}, [
		isQuestionPosted,
		isQuestionEdited,
		isQuestionDeleted,
		isQuestionNotExist,
	]);

	useEffect(() => {
		if (isQuestionPosted) {
			history.push('/Discuss');
		}
	}, [isQuestionPosted]);

	useEffect(() => {
		if (isQuestionEdited) {
			history.push(`/Discuss/${questionId}/${getQuestionAlias(title)}`);
		}
	}, [isQuestionEdited]);

	useEffect(() => {
		if (isQuestionDeleted) {
			history.replace('/Discuss');
		}
	}, [isQuestionDeleted]);

	useEffect(() => {
		if (isQuestionNotExist) {
			history.replace('/pagenotfound');
		}
	}, [isQuestionNotExist]);
};
